import { __assign } from '../../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './ItemContent.module.scss.js';

var ItemContent = function (_a) {
    var children = _a.children, rightIcon = _a.rightIcon, className = _a.className, style = _a.style;
    return (jsxs("div", __assign({ className: clsx(styles.itemContent, className), style: style }, { children: [children, jsx("div", __assign({ className: styles.rightIcon }, { children: rightIcon }))] })));
};

export { ItemContent };
